<template>
  <div class="welcome-to-origo-component h-100">

    <div class="container h-100">
      <div class="row h-100 align-items-center">
        <div class="col-12">
          <div class="card">
            <div class="row">
              <div class="col-12 right text-center">
                <div class="d-flex flex-column h-100 justify-content-center">
                  <div style="padding: 50px 0;">
                    <h1 style="color:#fff;padding-bottom:50px;">Logging in, please wait</h1>
                    <div style="padding-bottom:50px;"><LoadingIcon color="#fff"/></div>
                    <i class="logo-icon"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import LoadingIcon from "./loading-icon.vue";
import {EventBus} from "@/event-bus";

export default {
  components: {LoadingIcon},
  mounted() {
    // Opened by the session timeout modal to re-authenticate - hand back to the original window instead
    if (window.opener && window.name === 'origo-reauthenticate') {
      window.opener.postMessage({type: 'origo-reauthenticated'}, window.location.origin);
      window.close();
      return;
    }

    EventBus.$emit('fetchAdminPortalData', true);
    const redirect = this.$route.query.next ?? 'Agree to Proceed';
    this.$router.push({name: redirect, params: {...this.$route.params}});
  },
}
</script>
